import { isEqual } from 'lodash';

/**
 * Transform the string into an operator.
 *
 * @param {object} arg - The object argument.
 * @param {string} arg.operator - The operator in string form.
 * @param {number|string} arg.firstValue - The first value to confirm.
 * @param {number|string|object} arg.secondValue -  The second value to confirm.
 * @returns {boolean} - The result of the comparison.
 */

const getConditionFromOperator = ({ operator, firstValue, secondValue }) => {
  // eslint-disable-next-line eqeqeq
  if (operator === '==') return firstValue == secondValue;

  // eslint-disable-next-line eqeqeq
  if (operator === '!=') return firstValue != secondValue;

  if (operator === '===') return isEqual(firstValue, secondValue);

  if (operator === '!==') return !isEqual(firstValue, secondValue);

  if (operator === '<') return firstValue < secondValue;

  if (operator === '<=') return firstValue <= secondValue;

  if (operator === '>') return firstValue > secondValue;

  if (operator === '>=') return firstValue >= secondValue;

  if (operator === '<<') return secondValue.min < firstValue && firstValue < secondValue.max;

  if (operator === '<=<') return secondValue.min <= firstValue && firstValue < secondValue.max;

  if (operator === '<<=') return secondValue.min < firstValue && firstValue <= secondValue.max;

  if (operator === '<=<=') return secondValue.min <= firstValue && firstValue <= secondValue.max;

  return false;
};

export default getConditionFromOperator;
